module.exports = __webpack_public_path__ + "img/brand-logo.bfe18adf.png";